import styled from 'styled-components';
import RepairSelecction from '../repair/RepairSelecction';
import SpartPartSelecction from '../spartPart/SpartPartSelecction';
import CommonSpartPartSelecction from '../commonSpareParts/CommonSparePartsSelecction';
import AccessorySelection from '../accessory/AccessorySelecction';
import ManualsSelection from '../manuals/ManualsSelecction';

const SECTIONS = {
    equipo: {
        title: ' Repará tu equipo',
        iconClass: 'fa-solid fa-wrench',
        render: (product) => <RepairSelecction product={product} />,
    },
    repuestos: {
        title: 'Repuestos',
        iconClass: 'fa-solid fa-gear',
        render: (product) => <SpartPartSelecction product={product} />,
    },
    kit: {
        title: 'Kit',
        iconClass: 'fa-solid fa-gears',
        render: (product) => <CommonSpartPartSelecction product={product} />,
    },
    manuales: {
        title: 'Manuales',
        iconClass: 'fa-solid fa-book-open',
        render: (product) => <ManualsSelection product={product} />,
    },
    accesorios: {
        title: 'Accesorios',
        iconClass: 'fa-solid fa-plug',
        render: (product) => <AccessorySelection product={product} />,
    },
};

/**
 * Acordeón de secciones de un producto.
 *
 * Lo maneja React, no el JS de Bootstrap (no hay data-bs-toggle ni
 * data-bs-parent): la pestaña abierta viene de la URL. Se pierde la animación de
 * colapso de Bootstrap, y en cambio se gana que solo se monte la sección abierta
 * en lugar de las cinco, que era lo que disparaba decenas de requests por
 * producto seleccionado.
 */
export default function ProductSelection({ product, tabs, activeTab, onTabChange }) {
    if (!product) {
        return <h3 style={{ textAlign: 'center', margin: '2rem 0rem' }}>Seleccione una Marca y un Producto para ver Todo</h3>;
    }

    return (
        <div className="accordion">
            {tabs.map((key) => {
                const section = SECTIONS[key];
                if (!section) return null;

                const isOpen = key === activeTab;

                return (
                    <div className="accordion-item" key={key}>
                        <h2 className="accordion-header">
                            <AccordionButton
                                className={`accordion-button ${isOpen ? '' : 'collapsed'}`}
                                type="button"
                                onClick={() => onTabChange(key)}
                                aria-expanded={isOpen}
                                style={{ fontWeight: '700', fontSize: '1.5rem' }}
                            >
                                <i className={section.iconClass} style={{ marginRight: '1rem' }}></i>
                                {section.title}
                            </AccordionButton>
                        </h2>
                        <div className={`accordion-collapse collapse ${isOpen ? 'show' : ''}`}>
                            <div className="accordion-body">
                                {isOpen && section.render(product)}
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}


// Botón del acordeón con el estilo de fondo
const AccordionButton = styled.button`
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: -webkit-fill-available;
`;
